"use strict";

export class Spline {
    static getSplinePoint(nodes,t,out) {
        let count = nodes.length;
        let bigCount = count + 4;

        if (bigCount < 6) {
            out.x = 0;
            out.y = 0;
        } else {
            let delta = 1 / (count + 1);
            let times = [];
            times.push(0);
            for (let i = 0; i < count; i++) {
                times.push(times[i] + delta);
            }
            times.push(1);

            let segment = 0;
            while (segment < bigCount - 3) {
                if (t <= times[segment + 1]) break;
                segment++;
            }

            let t0 = times[segment];
            let t1 = times[segment + 1];
            let u = (t - t0) / (t1 - t0);

            segment += 3;

            let positions = [];
            positions.push({ x: nodes[0].x, y: nodes[0].y });
            positions.push({ x: nodes[0].x, y: nodes[0].y });
            for (let i = 0; i < count; i++) {
                positions.push({ x: nodes[i].x, y: nodes[i].y });
            }
            positions.push({ x: nodes[count - 1].x, y: nodes[count - 1].y });
            positions.push({ x: nodes[count - 1].x, y: nodes[count - 1].y });

            let A = {
                x: positions[segment].x - 3 * positions[segment - 1].x +
                    3 * positions[segment - 2].x - positions[segment - 3].x,
                y: positions[segment].y - 3 * positions[segment - 1].y +
                    3 * positions[segment - 2].y - positions[segment - 3].y
            };

            let B = {
                x: 3 * positions[segment - 1].x - 6 * positions[segment - 2].x +
                    3 * positions[segment - 3].x,
                y: 3 * positions[segment - 1].y - 6 * positions[segment - 2].y +
                    3 * positions[segment - 3].y,
            };

            let C = {
                x: 3 * positions[segment - 1].x - 3 * positions[segment - 3].x,
                y: 3 * positions[segment - 1].y - 3 * positions[segment - 3].y,
            };

            let D = {
                x: positions[segment - 1].x + 4 * positions[segment - 2].x + positions[segment - 3].x,
                y: positions[segment - 1].y + 4 * positions[segment - 2].y + positions[segment - 3].y,
            };

            out.x = (D.x + u * (C.x + u * (B.x + u * A.x))) / 6;
            out.y = (D.y + u * (C.y + u * (B.y + u * A.y))) / 6;
        }
    }
}